<template>
  <v-dialog v-model="dialog" @change="$emit('dialog-closed', dialog)">
    <v-card>
      <slot />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "p-pop-up",

  data: () => ({
    dialog: null,
  }),

  props: ["value"],

  watch: {
    value: {
      handler() {
        this.dialog = this.value;
      },
    },

    dialog: {
      handler() {
        if (!this.dialog) this.$emit("dialog-changed", this.dialog);
      },
    },
  },
};
</script>
